import React from "react";
import { Briefcase, ChevronRight, Building2 } from "lucide-react";
import { InfoCard, StatusBadge, EmptyState } from "../ui";

/**
 * StudentInterviews — Interview status card for student detail page.
 *
 * Props:
 *   interviews   — Array of interview objects
 *   onSchedule   — Handler for "Schedule" button
 */
const StudentInterviews = ({ interviews = [], onSchedule }) => (
  <InfoCard
    icon={<Briefcase size={16} />}
    iconClass="blue"
    title="Interview Status"
    action={
      onSchedule && (
        <button className="ui-card__action" onClick={onSchedule}>
          Schedule <ChevronRight size={10} />
        </button>
      )
    }
  >
    {interviews.length > 0 ? (
      interviews.slice(0, 4).map((iv) => {
        const isPlaced = iv.status === "placed";
        return (
          <div key={iv._id} className="ui-list-item">
            <div className={`sp-interview-icon ${isPlaced ? "sp-interview-icon--placed" : ""}`}>
              <Building2 size={16} />
            </div>
            <div className="ui-list-item__info">
              <div className="ui-list-item__name">{iv.companyName || iv.company || "—"}</div>
              <div className="ui-list-item__sub">
                {iv.nextRound || iv.title || "Interview"}
              </div>
            </div>
            <div className="ui-list-item__right">
              <StatusBadge status={isPlaced ? "placed" : iv.status === "ongoing" ? "ongoing" : "pending"}>
                {isPlaced
                  ? "Placed"
                  : iv.status === "ongoing"
                    ? `Round ${iv.roundNumber || 1}`
                    : iv.status || "Scheduled"
                }
              </StatusBadge>
            </div>
          </div>
        );
      })
    ) : (
      <EmptyState
        icon={<Briefcase size={20} />}
        title="No interviews scheduled"
      />
    )}
  </InfoCard>
);

export default StudentInterviews;
